import React from 'react';
import withIcon from '../utilities/withIcon';

const IconBadge = () => {
  return (
    <g>
      <path d="m8.4 6.7383a.7.7 0 0 0 .7.7h3.7715a.7.7 0 0 0 0-1.4h-3.7709a.7.7 0 0 0 -.7006.7z" />
      <path d="m12.8721 8.2729h-3.7715a.7.7 0 1 0 0 1.4h3.7715a.7.7 0 0 0 0-1.4z" />
      <path d="m12.8721 10.5083h-3.7715a.7.7 0 1 0 0 1.4h3.7715a.7.7 0 0 0 0-1.4z" />
      <path d="m6.6738 6.0381h-3.5361a.7.7 0 0 0 -.7.7v4.47a.7.7 0 0 0 .7.7h3.5361a.7.7 0 0 0 .7-.7v-4.47a.7.7 0 0 0 -.7-.7zm-.7 4.47h-2.1359v-3.07h2.1357z" />
      <path d="m15.1943 2.8745h-5.4648v-.0361a1.4179 1.4179 0 0 0 -1.416-1.4155h-.6279a1.417 1.417 0 0 0 -1.415 1.4155v.0361h-5.4649a.7.7 0 0 0 -.7.7v10.3025a.7.7 0 0 0 .7.7h14.3886a.7.7 0 0 0 .7-.7v-10.3023a.7.7 0 0 0 -.7-.7002zm-7.5234 0h.6582v1.4h-.6582zm6.8232 10.3022h-12.9882v-8.9018h4.7646v.0361a1.417 1.417 0 0 0 1.415 1.4155h.6279a1.4179 1.4179 0 0 0 1.4166-1.4155v-.0361h4.7647v8.9019z" />
    </g>
  );
};

export default withIcon(IconBadge);
